var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { fragment } from 'ember-data-model-fragments/attributes';
let MeasurementUnit = (_dec = attr('string', {
  defaultValue: CatalogObjectType.MEASUREMENT_UNIT,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/measurement-unit/data'), _dec3 = computed('measurementUnitData.measurementUnit.{areaUnit,lengthUnit,volumeUnit,weightUnit,timeUnit,genericUnit}'), (_class = (_class2 = class MeasurementUnit extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "measurementUnitData", _descriptor2, this);
  }
  get measurementUnitTypeKey() {
    if (this.measurementUnitData?.measurementUnit?.areaUnit) {
      return 'areaUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.lengthUnit) {
      return 'lengthUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.volumeUnit) {
      return 'volumeUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.weightUnit) {
      return 'weightUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.timeUnit) {
      return 'timeUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.genericUnit) {
      return 'genericUnit';
    }
    return 'customUnit';
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/measurement-unit'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "measurementUnitData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "measurementUnitTypeKey", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "measurementUnitTypeKey"), _class.prototype)), _class));
export { MeasurementUnit as default };